import React, { FC } from 'react';
import Grid from '@mui/material/Grid';
import TwField, { TwInputTypes } from '../../../components/TwFields/TwFields';
import { FormikValues } from 'formik';

interface CrossBorderDivisionFieldsProps {
  handleChange: FormikValues['handleChange'];
  values: {
    dot_number: string;
    scac: string;
    ca_carrier_code: string;
  };
}

export const CrossBorderDivisionFields: FC<CrossBorderDivisionFieldsProps> = ({
  values,
  handleChange
}) => {
  return (
    <Grid container columnSpacing={2}>
      <Grid item xs={12} md={3}>
        <TwField
          id="dot_number"
          name="dot_number"
          value={values.dot_number}
          label="DOT"
          placeholder=""
          inputType={TwInputTypes.text}
          onInputChange={(e): void => {
            if (e.target.value.length > 8) return;
            handleChange(e);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TwField
          id="scac"
          name="scac"
          value={values.scac}
          label="SCAC"
          placeholder=""
          inputType={TwInputTypes.text}
          onInputChange={(e): void => {
            if (e.target.value.length > 4) return;
            handleChange(e);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TwField
          id="ca_carrier_code"
          name="ca_carrier_code"
          value={values.ca_carrier_code}
          label="CA Carrier Code"
          placeholder=""
          inputType={TwInputTypes.text}
          onInputChange={(e): void => {
            if (e.target.value.length > 4) return;
            handleChange(e);
          }}
        />
      </Grid>
    </Grid>
  );
};
